export default __webpack_public_path__ + "static/media/buildActive.44b0be9c.svg";